import type { RouteMiddleware } from '#app'

export const onlyRuPage: RouteMiddleware = () => {
  const locale = useAppLocale()

  if (locale.isCis) {
    return abortNavigation({
      statusCode: 404,
    })
  }
}
